import React from "react";
import PdfViewerAdapter from "../PdfViewerAdapter/PdfViewerAdapter";
import ReactFileViewerAdapter from "../ReactFileViewerAdapter/ReactFileViewerAdapter";
import {
  FileViewerHandle,
  FileViewerAdapterProps,
} from "../FilePreviewer.types";

const FileViewerAdapter = React.forwardRef<
  FileViewerHandle,
  FileViewerAdapterProps
>(({ filePath, fileType, fileName, onZoomChange }, ref) => {
  if (fileType.toLowerCase() === "pdf") {
    return (
      <PdfViewerAdapter
        key={filePath}
        filePath={filePath}
        fileType={fileType}
        fileName={fileName}
        ref={ref}
        onZoomChange={onZoomChange}
      />
    );
  } else {
    return (
      <ReactFileViewerAdapter
        key={filePath}
        fileType={fileType.toLowerCase()}
        filePath={filePath}
        fileName={fileName}
        ref={ref}
        onZoomChange={onZoomChange}
      />
    );
  }
});

export default FileViewerAdapter;
